import { Link } from 'react-router-dom';
import './Footer.scss';

const Footer = () => {
    return (
        <footer className="footer">
            <div className="container content">
                <img 
                    src="/logos/Making-Biscuits-Logo-SVG-Inverse.svg" 
                    width={150}
                />
                <div className='nav-container'>
                    <nav className="collective-nav">
                        <h4>The Collective</h4>
                        <ul className="footer-links">
                            <li><a href="/about">Our Story</a></li>
                            <li><a href="/about#values">Mission and Values</a></li>
                            <li><a href="/about#leaders">Collective Leaders</a></li>
                        </ul>
                    </nav>
                    <nav className="connect-nav">
                        <h4>Connect with Us</h4>
                        <ul className="footer-links">
                            <li><a href="/connect">Request a Proposal</a></li>
                            <li><a href="/connect">Contact Us</a></li>
                            <li><a href="/careers">Careers</a></li>
                        </ul>
                    </nav>
                </div>
            </div>
            <div className="container copy">
                <span className="copyright">
                    Made with 🫶 by <strong>Making Biscuits Collective</strong>
                </span>
            </div>
        </footer>
    )
}

export default Footer;